// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-default {
  background: var(--anchor-wrapper-bg);
  width: 100%;
  height: 45px;
  -webkit-user-select: unset;
          user-select: unset;
}
.navbar-default .ant-tabs-nav::before {
  display: none !important;
}
.navbar-default .ant-tabs-nav-list {
  display: flex !important;
  flex-direction: unset;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  left: 0;
  top: 0;
  max-width: content-box;
  padding: 10px 0 0 0;
  width: 100%;
  white-space: nowrap;
}
.navbar-default .ant-tabs-nav-list .ant-tabs-tab {
  padding: 0 !important;
  margin: 0 !important;
  width: 200px;
  height: 35px;
  background: transparent !important;
  border: 1px solid transparent !important;
  border-bottom: 0 !important;
  border-radius: 10px 10px 0 0 !important;
  transition: none !important;
  max-width: max-content !important;
}
.navbar-default .ant-tabs-nav-list .ant-tabs-tab .ant-tabs-tab-btn {
  width: 100%;
  height: 100%;
  border-radius: 10px 10px 0 0 !important;
  transition: none;
}
.navbar-default .ant-tabs-nav-list .ant-tabs-tab-active {
  background: var(--background) !important;
}
.navbar-default .ant-tabs-nav-list .ant-tabs-tab-active .nav-link {
  color: var(--dark);
  background-color: var(--body-bg);
}
.navbar-default .ant-tabs-nav-list .ant-tabs-tab-active .nav-link::after {
  right: -100%;
  border-radius: 0 0 0 10px;
  box-shadow: -14px 0.25em 0 -4px var(--body-bg);
  opacity: 1;
  z-index: 1;
}
.navbar-default .ant-tabs-nav-list .ant-tabs-tab-active .nav-link::before {
  left: -100%;
  border-radius: 0 0 10px 0;
  box-shadow: 14px 0.25em 0 -4px var(--body-bg);
  opacity: 1;
  z-index: 1;
}
.navbar-default .ant-tabs-nav-list .nav-link {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  padding: 8px 16px;
  padding-right: 30px;
  border-radius: 10px 10px 0 0;
  text-decoration: none;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: var(--dark);
  text-transform: capitalize;
  transition: none;
}
.navbar-default .ant-tabs-nav-list .nav-link .nav-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.navbar-default .ant-tabs-nav-list .nav-link::after, .navbar-default .ant-tabs-nav-list .nav-link::before {
  content: " ";
  pointer-events: none;
  position: absolute;
  display: block;
  height: 80%;
  width: 100%;
  bottom: -1px;
  z-index: -1;
  opacity: 0;
}
.navbar-default .ant-tabs-nav-list .nav-link:hover {
  padding-left: 30px;
  text-decoration: none;
  background-color: var(--body-bg);
}
.navbar-default .ant-tabs-nav-list .nav-link:hover .reload-button {
  display: inline-block;
}
.navbar-default .ant-tabs-nav-list .nav-link .close-button {
  display: block;
  font-size: 10px;
  color: var(--dark);
  font-weight: 500;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  padding: 3px;
  margin: 0;
  border-radius: 50%;
}
.navbar-default .ant-tabs-nav-list .nav-link .close-button:hover {
  background-color: var(--sidebar-active);
}
.navbar-default .ant-tabs-nav-list .nav-link .reload-button {
  display: none;
  font-size: 10px;
  color: var(--dark);
  font-weight: 500;
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  padding: 3px;
  border-radius: 50%;
}
.navbar-default .ant-tabs-nav-list .nav-link .reload-button:hover {
  background-color: var(--sidebar-active);
}

.ant-tabs-dropdown .nav-link {
  width: 100%;
}
.ant-tabs-dropdown .nav-link .reload-button {
  display: none;
}
.ant-tabs-dropdown .nav-link span {
  padding: 5px;
}

[data-theme=dark] .navbar-default {
  background: var(--anchor-wrapper-bg);
}
[data-theme=dark] .navbar-default .ant-tabs-nav-list {
  background: var(--dark-background);
}
[data-theme=dark] .navbar-default .ant-tabs-nav-list .nav-link {
  color: var(--light-text);
}
[data-theme=dark] .navbar-default .ant-tabs-nav-list .nav-link .close-button,
[data-theme=dark] .navbar-default .ant-tabs-nav-list .nav-link .reload-button {
  color: var(--light-text);
}
[data-theme=dark] .navbar-default .ant-tabs-nav-list .nav-link:hover {
  background-color: rgba(27, 37, 49, 0.4);
}
[data-theme=dark] .navbar-default .ant-tabs-nav-list .ant-tabs-tab-active {
  background: var(--dark-blue) !important;
}
[data-theme=dark] .navbar-default .ant-tabs-nav-list .ant-tabs-tab-active .nav-link {
  background: var(--dark-blue);
  color: var(--light-text);
}
[data-theme=dark] .navbar-default .ant-tabs-nav-list .ant-tabs-tab-active .nav-link::after {
  box-shadow: -14px 0.25em 0 -4px var(--dark-blue);
}
[data-theme=dark] .navbar-default .ant-tabs-nav-list .ant-tabs-tab-active .nav-link::before {
  box-shadow: 14px 0.25em 0 -4px var(--dark-blue);
}
[data-theme=dark] .navbar-default .ant-tabs-nav-list .ant-tabs-tab-active .nav-link .close-button,
[data-theme=dark] .navbar-default .ant-tabs-nav-list .ant-tabs-tab-active .nav-link .reload-button {
  color: var(--light-text);
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/components/tabs.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;UAAA,kBAAA;AACF;AAAE;EACE,wBAAA;AAEJ;AACE;EACE,wBAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;AACJ;AAAI;EACE,qBAAA;EACA,oBAAA;EACA,YAAA;EACA,YAAA;EACA,kCAAA;EACA,wCAAA;EACA,2BAAA;EACA,uCAAA;EACA,2BAAA;EACA,iCAAA;AAEN;AADM;EACE,WAAA;EACA,YAAA;EACA,uCAAA;EACA,gBAAA;AAGR;AAAI;EACE,wCAAA;AAEN;AADM;EACE,kBAAA;EACA,gCAAA;AAGR;AAFQ;EACE,YAAA;EACA,yBAAA;EACA,8CAAA;EACA,UAAA;EACA,UAAA;AAIV;AAFQ;EACE,WAAA;EACA,yBAAA;EACA,6CAAA;EACA,UAAA;EACA,UAAA;AAIV;AACI;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,4BAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,gBAAA;AACN;AAAM;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AAER;AAAM;EAEE,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;AACR;AAEM;EACE,kBAAA;EACA,qBAAA;EACA,gCAAA;AAAR;AACQ;EACE,qBAAA;AACV;AAGM;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;AADR;AAEQ;EACE,uCAAA;AAAV;AAIM;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;EACA,kBAAA;AAFR;AAGQ;EACE,uCAAA;AADV;;AASE;EACE,WAAA;AANJ;AAOI;EACE,aAAA;AALN;AAOI;EACE,YAAA;AALN;;AAUA;EACE,oCAAA;AAPF;AAQE;EACE,kCAAA;AANJ;AAOI;EACE,wBAAA;AALN;AAMM;;EAEE,wBAAA;AAJR;AAMM;EACE,uCAAA;AAJR;AAOI;EACE,uCAAA;AALN;AAMM;EACE,4BAAA;EACA,wBAAA;AAJR;AAKQ;EACE,gDAAA;AAHV;AAKQ;EACE,+CAAA;AAHV;AAKQ;;EAEE,wBAAA;AAHV","sourcesContent":[".navbar-default {\n  background: var(--anchor-wrapper-bg);\n  width: 100%;\n  height: 45px;\n  user-select: unset;\n  .ant-tabs-nav::before {\n    display: none !important;\n  }\n\n  .ant-tabs-nav-list {\n    display: flex !important;\n    flex-direction: unset;\n    flex-wrap: nowrap;\n    overflow-x: auto;\n    overflow-y: hidden;\n    left: 0;\n    top: 0;\n    max-width: content-box;\n    padding: 10px 0 0 0;\n    width: 100%;\n    white-space: nowrap;\n    .ant-tabs-tab {\n      padding: 0 !important;\n      margin: 0 !important;\n      width: 200px;\n      height: 35px;\n      background: transparent !important;\n      border: 1px solid transparent !important;\n      border-bottom: 0 !important;\n      border-radius: 10px 10px 0 0 !important;\n      transition: none !important;\n      max-width: max-content !important;\n      .ant-tabs-tab-btn {\n        width: 100%;\n        height: 100%;\n        border-radius: 10px 10px 0 0 !important;\n        transition: none;\n      }\n    }\n    .ant-tabs-tab-active {\n      background: var(--background) !important;\n      .nav-link {\n        color: var(--dark);\n        background-color: var(--body-bg);\n        &::after {\n          right: -100%;\n          border-radius: 0 0 0 10px;\n          box-shadow: -14px 0.25em 0 -4px var(--body-bg);\n          opacity: 1;\n          z-index: 1;\n        }\n        &::before {\n          left: -100%;\n          border-radius: 0 0 10px 0;\n          box-shadow: 14px 0.25em 0 -4px var(--body-bg);\n          opacity: 1;\n          z-index: 1;\n        }\n      }\n    }\n\n    .nav-link {\n      position: relative;\n      overflow: hidden;\n      width: 100%;\n      height: 100%;\n      padding: 8px 16px;\n      padding-right: 30px;\n      border-radius: 10px 10px 0 0;\n      text-decoration: none;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      font-weight: 500;\n      font-size: 14px;\n      line-height: 18px;\n      color: var(--dark);\n      text-transform: capitalize;\n      transition: none;\n      .nav-text {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n      &::after,\n      &::before {\n        content: ' ';\n        pointer-events: none;\n        position: absolute;\n        display: block;\n        height: 80%;\n        width: 100%;\n        bottom: -1px;\n        z-index: -1;\n        opacity: 0;\n      }\n\n      &:hover {\n        padding-left: 30px;\n        text-decoration: none;\n        background-color: var(--body-bg);\n        .reload-button {\n          display: inline-block;\n        }\n      }\n\n      .close-button {\n        display: block;\n        font-size: 10px;\n        color: var(--dark);\n        font-weight: 500;\n        position: absolute;\n        right: 10px;\n        top: 50%;\n        transform: translateY(-50%);\n        padding: 3px;\n        margin: 0;\n        border-radius: 50%;\n        &:hover {\n          background-color: var(--sidebar-active);\n        }\n      }\n\n      .reload-button {\n        display: none;\n        font-size: 10px;\n        color: var(--dark);\n        font-weight: 500;\n        position: absolute;\n        left: 10px;\n        top: 50%;\n        transform: translateY(-50%);\n        padding: 3px;\n        border-radius: 50%;\n        &:hover {\n          background-color: var(--sidebar-active);\n        }\n      }\n    }\n  }\n}\n\n.ant-tabs-dropdown {\n  .nav-link {\n    width: 100%;\n    .reload-button {\n      display: none;\n    }\n    span {\n      padding: 5px;\n    }\n  }\n}\n\n[data-theme='dark'] .navbar-default {\n  background: var(--anchor-wrapper-bg);\n  .ant-tabs-nav-list {\n    background: var(--dark-background);\n    .nav-link {\n      color: var(--light-text);\n      .close-button,\n      .reload-button {\n        color: var(--light-text);\n      }\n      &:hover {\n        background-color: rgba($color: #1b2531, $alpha: 0.4);\n      }\n    }\n    .ant-tabs-tab-active {\n      background: var(--dark-blue) !important;\n      .nav-link {\n        background: var(--dark-blue);\n        color: var(--light-text);\n        &::after {\n          box-shadow: -14px 0.25em 0 -4px var(--dark-blue);\n        }\n        &::before {\n          box-shadow: 14px 0.25em 0 -4px var(--dark-blue);\n        }\n        .close-button,\n        .reload-button {\n          color: var(--light-text);\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
